import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Box } from "native-base";
import { forHumans } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import { useChart } from "../../providers/chart";
import Graph from "../Graph";
const GraphPredictionWrapper = ({ metricType, graphProps, predictionTrend, }) => {
    const [graphWidth, setGraphWidth] = useState();
    const { dateRange } = useChart();
    const { t } = useTranslation();
    const resolvedProps = useMemo(() => (Object.assign(Object.assign({}, graphProps), { predictions: predictionTrend
            ? {
                isPrediction: true,
                startMsec: dateRange.from.getTime(),
                high: {
                    regression: {
                        // slope is per day, chart needs per msec
                        gradient: predictionTrend.slope / 86400000,
                        startY: predictionTrend.intercept,
                    },
                    spread: {
                        halfDegInner: 7,
                        halfDegOuter: 14,
                    },
                },
            }
            : undefined, slot: { x: graphWidth !== null && graphWidth !== void 0 ? graphWidth : 600, y: 400 }, paddingPercents: { x: 3, y: 3 }, dashboardThumbnail: {
            title: t(`measures:${forHumans(metricType)}`),
            isDashboardThumbnail: false,
            showLineGraphNodes: true,
        } })), [graphProps, predictionTrend, dateRange.from, graphWidth, t, metricType]);
    return (_jsx(Box, Object.assign({ onLayout: (e) => setGraphWidth(e.nativeEvent.layout.width), width: "100%" }, { children: _jsx(Graph, { graphProps: resolvedProps }) })));
};
export default GraphPredictionWrapper;
